import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/http";

/**
 * First-login calorie setup: clients whose profile has no calorie target
 * (and no body data) get redirected once to /onboarding, which auto-runs
 * the macro calculator after they fill in age/height/weight/goal.
 */
export default function OnboardingGate() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role !== "client") return;
    if (location.pathname.startsWith("/onboarding")) return;
    if (sessionStorage.getItem("solano_onb_checked")) return;
    sessionStorage.setItem("solano_onb_checked", "1");
    (async () => {
      try {
        const { data: p } = await api.get("/client/profile");
        const incomplete = !p?.daily_calories_target && !p?.age && !p?.height_cm;
        if (incomplete) navigate("/onboarding", { replace: true });
      } catch { /* profile fetch failed — don't block the app */ }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.role]);

  return null;
}
